import { Table } from 'components/tables/Table';
import { FunctionComponent } from 'react';
import { AuditLogEvent } from './AuditLogEvent';
import { ColumnDef } from '@tanstack/react-table';
import { RequestStatus } from 'types/RequestStatus';

export const AuditLogTable: FunctionComponent<{
	data: AuditLogEvent[];
	requestStatus: RequestStatus;
	columns: ColumnDef<AuditLogEvent, string>[];
}> = ({ data, requestStatus, columns }) => (
	<Table<AuditLogEvent>
		header="Audit Log"
		requestStatus={requestStatus}
		data={data}
		columns={columns}
		withPagination={data?.length > 10}
		showRowCount={data?.length > 10}
		initialSorting={[
			{
				id: 'time',
				desc: true,
			},
		]}
	/>
);
